import React from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";

//
import { showPlanModal } from "../../redux/features/plan/slice";

function SubscriptionAlarm({ showPlanModal }) {
  return (
    <div className="subscription-alarm">
      Please subscribe to get full access and receive new alerts.
      <a onClick={() => showPlanModal({ show: true, step: "choose-plan", type:"plan" })}>
        See Pricing
      </a>
    </div>
  );
}

const mapDispatchToProps = {
  showPlanModal,
};

SubscriptionAlarm.propTypes = {
  showPlanModal: PropTypes.func.isRequired,
};

export default connect(null, mapDispatchToProps)(SubscriptionAlarm);
